/**
 * DeployCohortCoursewareModal Messages
 *
 * This contains all the text for the DeployCohortCoursewareModal component.
 */
import { defineMessages } from 'react-intl';

const scope = 'app.workspace.cohorts.courseware';

export default defineMessages({
  selectCourseware: {
    id: `${scope}.selectCourseware`,
    defaultMessage: 'Select Courseware',
  },
  searchCourseware: {
    id: `${scope}.searchCourseware`,
    defaultMessage: 'Search courseware',
  },
  selectProject: {
    id: `${scope}.selectProject`,
    defaultMessage: 'Select Project',
  },
  lockPluginVersionTitle: {
    id: `${scope}.lockPluginVersionTitle`,
    defaultMessage: 'Courseware Settings',
  },
  lockPluginVersionCheckboxLabel: {
    id: `${scope}.lockPluginVersionCheckboxLabel`,
    defaultMessage: 'Lock down plugin versions',
  },
  lockPluginVersionDescription: {
    id: `${scope}.lockPluginVersionDescription`,
    defaultMessage: 'Fixes all plugins to their current version.',
  },
  lockPluginVersionDescriptionItalic: {
    id: `${scope}.lockPluginVersionDescriptionItalic`,
    defaultMessage: 'If a plugin is updated you\'ll need to re-deploy your courseware to view the changes.',
  },
  scorable: {
    id: `${scope}.scorable`,
    defaultMessage: 'Scorable Interactive Reading Assignment',
  },
  forceUpdateAssessments: {
    id: `${scope}.forceUpdateAssessments`,
    defaultMessage: 'Force Update Assessments',
  },
  scorableDescriptionItalic: {
    id: `${scope}.scorableDescriptionItalic`,
    defaultMessage: 'Select this option to create or update a scored courseware homework assignment such as ILabs, IRAs with TDX, Journals. DO NOT select this option for CRX.',
  },
  forceUpdateAssessmentsDescriptionItalic: {
    id: `${scope}.forceUpdateAssessmentsDescriptionItalic`,
    defaultMessage: 'Select this option only if you have modified existing LTA metadata fields such as TDX, Journals, CodeGrade.',
  },
  supportOnDemandClassesCheckboxLabel: {
    id: `${scope}.supportOnDemandClassesCheckboxLabel`,
    defaultMessage: 'Support On-Demand Classes',
  },
  deployAsLibraryCheckboxLabel: {
    id: `${scope}.deployAsLibraryCheckboxLabel`,
    defaultMessage: 'Deploy as Library',
  },
  deployAsLibraryDescriptionItalic: {
    id: `${scope}.deployAsLibraryDescriptionItalic`,
    defaultMessage: 'Makes this course available in the Modal Card course selector.',
  },
  deployAsLibraryAlreadyInLibraryDescription: {
    id: `${scope}.deployAsLibraryAlreadyInLibraryDescription`,
    defaultMessage: 'This course is already available in the library.',
  },
  searchProject: {
    id: `${scope}.searchProject`,
    defaultMessage: 'Search project',
  },
  cancelButton: {
    id: `${scope}.cancelButton`,
    defaultMessage: 'Cancel',
  },
  nextButton: {
    id: `${scope}.nextButton`,
    defaultMessage: 'Next',
  },
  deployButton: {
    id: `${scope}.deployButton`,
    defaultMessage: 'Deploy',
  },
});
